import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PulseLoaderService } from './pulse-loader.service';

@Component({
  selector: 'app-pulse-loader',
  templateUrl: './pulse-loader.component.html',
  styleUrls: ['./pulse-loader.component.scss']
})
export class PulseLoaderComponent implements OnInit {
  loading: boolean = false;
  error: boolean = false;

  constructor(public loader: PulseLoaderService) {
  }

  ngOnInit(): void {
    this.loader.loading$.subscribe((val) => {
      this.loading = typeof val.loading != "undefined" ? val.loading : this.loading;
      this.error = typeof val.error != "undefined" ? val.error : this.error;
    })
  }

}
